/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RefreshKeyRequest} from '@cash-web/protos/squareup/hieroglyph/hieroglyph.pb'
import {RefreshKeyResponse} from '@cash-web/protos/squareup/hieroglyph/hieroglyph.pb'


export const refreshKey = (request: RefreshKeyRequest, options?: CashRequestOptions) => post<RefreshKeyRequest, RefreshKeyResponse>("/2.0/cash/refresh-key", request, {...options, rejectOnError: true })